import React from 'react';
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import Slider from 'react-slick';
import './FinQBanner.css';
import finqImage from '../../../images/finqImage.png';
// import FinQBannerImage from '../../../images/Inner Page/Fin Q.jpg';
import FinQBannerImage from '../../../images/Inner Page/FinQ.jpg';
import InsightsImage from "../../../images/Inner Page/Insights_new.jpg"
function FinQBanner() {
   
    return (
        <>
            <section className='banner-sc download-banner'>
                {/* <section className='home-banner-main'>
                    <Container>
                        <Row>
                            <Col sm={12}>
                                <div className='banner-content'>
                                    <h1 className='FinQBannerHead'>Fin<img src={finqImage} alt='FinQImage' /></h1>
                                    <p>A knowledge center is an Internet-based community or system designed to help people remotely share information. Knowledge centers offer a variety of tools and accessories that enable the immediate or delayed sending and receiving of information.</p>
                                  
                                </div>
                                
                            </Col>
                        </Row>
                    </Container>
                </section> */}

                       <section className="banner-slider">
            <div className="home-banner-sc">
              <div className="banner-container">
                <img
                  src={InsightsImage}
                  alt="Insights Banner"
                  className="banner-image"
                />
                
                {/* Text Overlay on Left Side */}
                <div className="banner-text-overlay">
                  <div className="insights-banner-contents">
                    <h1 className="banner-title">Insights</h1>
                  </div>
                </div>
              </div>
            </div>
</section>
            </section>
        </>
    );
}

export default FinQBanner;